import { PowermeterHistory, PowermeterType } from 'src/Types/responses/powermeter-values/{sn}'
import { Wallbox, WallboxHistory } from 'src/Types/responses/wallboxes/{sn}'

export enum FetchingState {
  FETCHING = 'FETCHING',
  FETCHED = 'FETCHED',
}

export interface StatObject {
  first: number
  last: number
  count: number
}
export interface HistoryData {
  time: number
  BatPowerIn: number
  BatPowerOut: number
  NetIn: number
  NetOut: number
  Consumption: number
  ASOC: number
  DC_Power: number
  DC_PowerL1: number
  DC_PowerL2: number
  DC_PowerL3: number
  Consumption_delta: number
  BatPowerIn_delta: number
  BatPowerOut_delta: number
  NetIn_delta: number
  NetOut_delta: number
  DC_PowerL1_delta: number
  DC_PowerL2_delta: number
  WeatherBreakthrough?: boolean
  Temperature?: number
  dischargeEnergy?: number
  selfProduction?: number
}

export interface TemperatureData {
  time: number
  value: number | null
}

export interface StorageInfo {
  version?: number
  timezone?: string
  info: StorageInfoData
  wallboxes?: Wallbox[]
}

export interface StorageInfoData {
  batteryCapacity: number
  batteryPower: number
  derateAtPower: number
  sw_release: string
}

export type HistoryInfo = {
  version?: number
  info: StatObject
}

export type ForecastInfo = {
  version: number
}

export type BreakthroughInfo = {
  version: number
}

export interface WallboxInformation {
  count: number
  first: number
  last: number
}

export interface WallboxInfoArray {
  id: number
  number: number
  info: WallboxInformation
}

export type WallboxInfo = {
  version?: number
  wallboxes: WallboxInfoArray[]
}

export type PowermeterInfoArray = {
  id: number
  type: PowermeterType[] | undefined
  info: unknown
  storageId: string
  uniqueId: string
}

export type PowermeterInfo = {
  version?: number
  powermeters: PowermeterInfoArray[]
}

export type BatteryInfo = {
  version?: number
  batteries: unknown[]
}

export interface BatteryTrainingModel {
  batIndex: number
  batTrainingMode: BatteryTrainingMode
}

export enum BatteryTrainingModes {
  Inactive = 0,
  Active = 2,
}

export type BatteryTrainingMode = BatteryTrainingModes

export type SystemInfo = {
  serialNo: string
  storage: StorageInfo
  history: HistoryInfo
  wallboxes: WallboxInfo
  powermeters: PowermeterInfo
  batteries: BatteryInfo
  error?: string
}

export type SystemInfoState = {
  [serialno: string]: {
    state: undefined | 'FETCHED' | 'FETCHING'
    data?: SystemInfo
    currentTs: number
    error?: string
  }
}

export interface HistoryState {
  [serialno: string]: {
    [from: number]: {
      data: HistoryData[]
      wallboxes?: Record<string, WallboxHistory[]>
      powermeters?: Record<string, PowermeterHistory[]>
      state: undefined | 'FETCHED' | 'FETCHING'
      completed: boolean
      first?: string
      last?: string
    }
  }
}
export interface ForecastData {
  time: number
  batteryPowerIn: number
  batteryPowerOut: number
  netIn: number
  netOut: number
  consumption: number
  asoc: number
  forecastPower: number
  batteryCapacity: number
  batteryPowerIn_delta: number
  batteryPowerOut_delta: number
  netIn_delta: number
  netOut_delta: number
  consumption_delta: number
  [key: string]: number | boolean | undefined
  // DC_PowerL1: number
  // DC_PowerL2: number
  WeatherBreakthrough?: boolean

  Wallbox_energySolar?: number
  Wallbox_energyAll?: number
  Wallbox_energyDischarged?: number
  Wallbox_energyNetOut?: number
}
export interface ForecastPower {
  time: number
  power: number | null
}

export interface ForecastState {
  [serialno: string]: {
    [from: number]: ForecastPower[]
  }
}

export interface ForecastDataState {
  [serialno: string]: ForecastData[]
}

export interface BreakthroughState {
  [serialno: string]: {
    [from: number]: Breakthrough[]
  }
}

export interface ErrorState {
  [serialno: string]: Error | undefined
}

export interface Breakthrough {
  date: string
  deratePowerAt: number
}

export interface FetchState {
  [serialno: string]: {
    [from: number]: FetchingState
  }
}

export type VersionState = {
  version?: string
}
